import { Action } from 'redux';
import { isType } from 'typescript-fsa';
import * as actions from './actions';
import { IotHubState } from './types';

export const initialIotHubState: IotHubState = {
	edgeModule: undefined,
	edgeAgent: undefined,
	connectionString: undefined,
	isLoading: false,
	error: undefined,
};

export default function reducer(state: IotHubState = initialIotHubState, action: Action): IotHubState {
	if (isType(action, actions.resetIotHubState)) {
		return initialIotHubState;
	}

	if (
		isType(action, actions.getDeviceProxyPropertiesAsync.started) ||
		isType(action, actions.setDeviceProxyPropertiesAsync.started) ||
		isType(action, actions.getDeviceEdgeAgentPropertiesAsync.started) ||
		isType(action, actions.getDeviceConnectionStringAsync.started)
	) {
		// All reads for a device dispatch their `started` synchronously when the panel opens
		// (before any response), so clearing the error here resets it per fetch cycle.
		return { ...state, isLoading: true, error: undefined };
	}

	if (
		isType(action, actions.getDeviceProxyPropertiesAsync.done) ||
		isType(action, actions.setDeviceProxyPropertiesAsync.done)
	) {
		return { ...state, edgeModule: action.payload.result, isLoading: false };
	}

	if (isType(action, actions.getDeviceEdgeAgentPropertiesAsync.done)) {
		return { ...state, edgeAgent: action.payload.result, isLoading: false };
	}

	if (isType(action, actions.getDeviceConnectionStringAsync.done)) {
		return { ...state, connectionString: action.payload.result, isLoading: false };
	}

	if (
		isType(action, actions.getDeviceProxyPropertiesAsync.failed) ||
		isType(action, actions.setDeviceProxyPropertiesAsync.failed) ||
		isType(action, actions.getDeviceEdgeAgentPropertiesAsync.failed) ||
		isType(action, actions.getDeviceConnectionStringAsync.failed)
	) {
		return { ...state, isLoading: false, error: action.payload.error?.message || 'error' };
	}

	return state;
}
